<template>
    <div>

        <v-dialog
            v-model="display"
            persistent
            width="500">
            <v-card>
                <v-card-title>{{title}}</v-card-title>
                <v-card-subtitle>{{ $t('ITEM_SUBTITLE') }}</v-card-subtitle>
                <v-card-text>
                    <div
                        class="text-center"
                        v-if="loading.data">
                        <v-progress-circular
                            indeterminate
                            color="primary">
                        </v-progress-circular>
                    </div>
                    <v-form
                        v-model="valid"
                        ref="form"
                        v-else>
                        <v-text-field
                            :label="$t('ITEM_NAME')"
                            v-model="form.name"
                            :rules="rules.name">
                        </v-text-field>

                        <v-text-field
                            :label="$t('ITEM_PART_NUMBER')"
                            v-model="form.part_number">
                        </v-text-field>

                        <v-textarea
                            :label="$t('ITEM_DESCRIPTION')"
                            v-model="form.description"
                            v-if="!mode.mini">
                        </v-textarea>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        :loading="loading.submit"
                        :disabled="!valid || loading.data || loading.submit"
                        @click="submit">
                        {{ $t('BTN_SAVE') }}
                    </v-btn>
                    <v-btn
                        text
                        @click="close">
                        {{ $t('BTN_CANCEL') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <AlertDialog
            ref="alertDialog"/>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import AlertDialog from '../components/AlertDialog';
export default {
    name: "ItemDialog",
    components: {
        AlertDialog
    },
    props: {
        miniMode: Boolean
    },
    data() {
        return {
            display: false,
            valid: false,
            mode: {
                edit: false,
                mini: false
            },
            loading: {
                data: true,
                submit: false
            },
            form: {
                id: null,
                name: null,
                part_number: null,
                description: null
            },
            rules: {
                name: [
                    v => !!v || this.$t('RULES_REQUIRED_MSG')
                ]
            }
        }
    },
    computed: {
        ...mapState("item", ["item"]),
        title() {
            if(!this.mode.edit) return this.$t('ITEM_NEW_TITLE');
            else return this.$t('ITEM_EDIT_TITLE');
        }
    },
    methods: {
        ...mapActions("item", ["fetchItem", "fetchItems", "storeItem", "updateItem"]),
        async open(params) {
            this.loading.data = true;
            this.mode.edit = params.editMode;
            this.mode.mini = this.miniMode;
            this.display = true;
            if(this.mode.edit) {
                await this.fetchItem(params.id);
                this.form = {...this.item};
            }
            this.loading.data = false;
        },
        close() {
            this.display = false;
            setTimeout(() => {
                this.loading.submit = false;
                this.$refs.form.reset();
                this.$refs.form.resetValidation();
            }, 500);
        },
        submit() {
            this.loading.submit = true;
            if(!this.mode.edit) {
                this.storeItem(this.form)
                    .then(response => {
                        this.close();
                        this.$emit("record", response.record);
                        this.$emit("submit");
                        this.$refs.alertDialog.open(this.$t('SUCCESS_TITLE'), response.message);
                    })
                    .catch(error => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t('ERROR_TITLE'), error.message);
                    });
            } else {
                this.updateItem(this.form)
                    .then(response => {
                        this.close();
                        this.$emit("submit");
                        this.$refs.alertDialog.open(this.$t('SUCCESS_TITLE'), response.message);
                    })
                    .catch(error => {
                        this.close();
                        this.$refs.alertDialog.open(this.$t('ERROR_TITLE'), error.message);
                    });
            }
        }
    }
}
</script>